import styled, { css } from 'styled-components';
import { ApMenu, colors } from '@alixpartners/ui-components';

export const StyledMenu = styled(ApMenu)`
	padding-bottom: 0 !important;
	overflow: hidden !important;
	display: flex;
	flex-direction: column;
	max-width: 272px !important;
	min-width: 200px !important;
	max-height: calc(100% - 102px) !important;

	${({ isVirtualList }) =>
		isVirtualList &&
		css`
			height: 100%;
		`};
`;

export const CounterWrapper = styled.div`
	position: absolute;
	right: 8px;
	top: -8px;
	border-radius: 16px;
	background-color: ${colors.green2};
	height: 16px;
	min-width: 16px;
	color: white;
	font-size: 11px;
	font-weight: 500;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 4px;
	z-index: 2;
`;
